<script context="module">
	/*import { browser, dev } from '$app/env';*/
  import { categories } from '../stores';
/*
	// we don't need any JS on this page, though we'll load
	// it in dev so that we get hot module replacement...
	export const hydrate = dev;

	// ...but if the client-side router is already loaded
	// (i.e. we came here from elsewhere in the app), use it
	export const router = browser;

	// since there's no dynamic data here, we can prerender
	// it so that it gets served as a static asset in prod
	export const prerender = true;
  */
</script>

<svelte:head>
	<title>About</title>
	<meta name="description" content="About this app" />
</svelte:head>

<div class="content">
	<div class="col pt-2" style="background-color: #F0EFF0;">
		<div class=""><h5>RACE CATEGORIES</h5></div>
		<br />
		
		<table class="table table-striped">
			<thead class="table-dark">
				<tr>
					<th class="text-start" scope="col">Category</th>
					<th scope="col">Age</th>
				</tr>
			</thead>
			<tbody>
				{#each $categories as {name, age_range}}
			<tr>
				<td class="text-start text-capitalize">{name}</td>
				<td class="text-capitalize">{age_range}</td>
			</tr>
				{/each}
			</tbody>
		</table>
	</div>
</div>

<style>
	.content {
		width: 100%;
		max-width: var(--column-width);
		margin: var(--column-margin-top) auto 0 auto;
	}
</style>
